export const RiskQuizSetupContent = {
  pageTitle: `Next up: Let's see how you feel about risk`,
};
